import { validatorStringTextOnly } from "./validatorStringTextOnly";

const MIN_LETTERS = 2;
const LETTER_RE = /[a-zA-ZÀ-ſ]/g; // Latin letters incl. accented (handles Öğün, García, etc.)

export const validatorName = validatorStringTextOnly.test(
  "min-letters",
  `Should contain at least ${MIN_LETTERS} letters`,
  (value) => {
    if (!value) return true; // let .required() catch empties
    return (value.match(LETTER_RE) ?? []).length >= MIN_LETTERS;
  }
);
